"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ClaimBase_1 = require("./ClaimBase");
var MotorClaim = /** @class */ (function (_super) {
    __extends(MotorClaim, _super);
    function MotorClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MotorClaim.getClaimType = function (claimTypeId) {
        switch (claimTypeId) {
            case 1: return "Accident - you hit somebody/something";
            case 2: return "Accident - you/somebody hit each other";
            case 3: return "Accident - somebody/something hit you";
            case 4: return "Windscreen/Window glass";
            case 5: return "Malicious damage/Vandalism";
            case 6: return "Theft of vehicle";
            case 7: return "Theft from vehicle";
            case 8: return "Fire";
            case 9: return "Storm/Flood/Weather damage";
        }
        throw new Error("Unknown claim type id: ".concat(claimTypeId));
    };
    MotorClaim.claimCount = 9;
    MotorClaim.claimTypeStartId = 1;
    return MotorClaim;
}(ClaimBase_1.default));
exports.default = MotorClaim;
//# sourceMappingURL=MotorClaim.js.map